import dayjs from 'dayjs'

export const after14DayDate = dayjs().add(14, 'days').toDate()
